import { makePublicServiceRequest } from './servicesClient';

export function uploadsUrl(uploadId = '') {
    return `https://uploads.documents.cimpress.io/v1/uploads/${uploadId}?tenant=default`;
}

export function uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return makePublicServiceRequest({
        method: 'post',
        url: uploadsUrl(),
        data: formData,
    });
}



// WEBPACK FOOTER //
// ./src/services/uploadsClient.js